import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import moment from 'moment';

// Style
import 'react-dates/initialize';

import { DateRangePicker, isInclusivelyBeforeDay, isInclusivelyAfterDay } from 'react-dates';
import { START_DATE, END_DATE } from 'react-dates/constants';

// Bootstrap components for tooltip
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';

// Redux
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

// Redux Action
import { change } from 'redux-form';
import { checkAvailability } from '../../../actions/checkAvailability';

import { getSpecialPricingData } from '../../../actions/Listing/getSpecialPricingData';
import CustomBookingFormDay from "./CustomBookingFormDay";

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';

// Locale
import messages from '../../../locale/messages';

//Helper
import { isRTL } from '../../../helpers/formatLocale';
import { getDateUsingTimeZone } from '../../../helpers/dateRange';

import withStyles from 'isomorphic-style-loader/withStyles';
import s from 'react-dates/lib/css/_datepicker.css';

class DateRange extends React.Component {
  static propTypes = {
    minimumNights: PropTypes.number.isRequired,
    maximumNights: PropTypes.number.isRequired,
    checkAvailability: PropTypes.any.isRequired,
    blockedDates: PropTypes.array.isRequired,
    listId: PropTypes.number.isRequired,
    formName: PropTypes.string.isRequired,
    maxDaysNotice: PropTypes.string.isRequired,
    formatMessage: PropTypes.any,
    country: PropTypes.string.isRequired,
    weekendPrice: PropTypes.number,
    minStayWeekend: PropTypes.bool
  };

  static defaultProps = {
    blockedDates: [],
    maxDaysNotice: 'unavailable',
    country: ''
  }

  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
      startDate: null,
      endDate: null,
      blockedDates: [],
      blockedDatesValues: [],
      isLoaderLanguage: false,
      dynamicMinimumNights: props.minimumNights || 1,
      showMinStayTooltip: false,
      tooltipPosition: { x: 0, y: 0 }
    };

    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.isDayBlocked = this.isDayBlocked.bind(this);
    this.calculateDynamicMinimumNights = this.calculateDynamicMinimumNights.bind(this);
    this.handleCalendarClick = this.handleCalendarClick.bind(this);
  }
  componentDidMount() {
    const { bookingStartDate, bookingEndDate, blockedDates, contactStartDate, contactEndDate, isFullDayBlock, locale } = this.props;
    const { formName } = this.props;
    const blockedDatesSet = new Set();

    // Track global mouse position
    this.trackMousePosition = (event) => {
      this.lastMousePosition = {
        x: event.clientX,
        y: event.clientY
      };
    };
    document.addEventListener('mousemove', this.trackMousePosition);

    if (formName == 'BookingForm') {
      if (bookingStartDate && bookingEndDate) {
        this.setState({
          startDate: moment(moment(bookingStartDate).format('YYYY-MM-DD')),
          endDate: moment(moment(bookingEndDate).format('YYYY-MM-DD')),
        });
      }
    }

    if (formName == 'ContactHostForm') {
      if (contactStartDate && contactEndDate) {
        this.setState({
          startDate: moment(moment(contactStartDate).format('YYYY-MM-DD')),
          endDate: moment(moment(contactEndDate).format('YYYY-MM-DD')),
        });
      }
    }

    isFullDayBlock.forEach(day => {
      if (day.calendarStatus != 'available') {
        blockedDatesSet.add(moment(day.blockedDates).format('YYYY-MM-DD'));
      }
    });

    this.setState({ blockedDatesSet });
    this.setState({ blockedDatesValues: blockedDates, isLoaderLanguage: true });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { bookingStartDate, bookingEndDate, blockedDates, contactStartDate, contactEndDate, isFullDayBlock, locale } = nextProps;
    const { formName } = nextProps;
    const { blockedDatesSet } = this.state;

    if (formName == 'ContactHostForm') {
      if (contactStartDate && contactEndDate) {
        this.setState({
          startDate: moment(moment(contactStartDate).format('YYYY-MM-DD')),
          endDate: moment(moment(contactEndDate).format('YYYY-MM-DD')),
        });
      } else if (!contactEndDate) {
        this.setState({
          endDate: null
        });
      }
    }

    if (formName == 'BookingForm') {
      if (bookingStartDate && bookingEndDate) {
        this.setState({
          startDate: moment(moment(bookingStartDate).format('YYYY-MM-DD')),
          endDate: moment(moment(bookingEndDate).format('YYYY-MM-DD')),
        });
      } else if (!bookingEndDate) {
        this.setState({
          endDate: null
        });
      }
    }


    isFullDayBlock.forEach(day => {
      if (day.calendarStatus != 'available') {
        blockedDatesSet.add(moment(day.blockedDates).format('YYYY-MM-DD'));
      }
    });

    this.setState({ blockedDatesSet });
    this.setState({ blockedDatesValues: blockedDates, isLoaderLanguage: true });

  }

  componentWillUnmount() {
    if (this.trackMousePosition) {
      document.removeEventListener('mousemove', this.trackMousePosition);
    }
  }

  handleCalendarClick(event) {
    // Store mouse position for tooltip
    console.log('[TOOLTIP_DEBUG] Click position:', event.clientX, event.clientY);
    this.setState({
      tooltipPosition: {
        x: event.clientX,
        y: event.clientY
      }
    });
  }

  async onDatesChange({ startDate, endDate }) {
    const { focusedInput } = this.state;
    const { listId, formName, checkAvailability, change, maximumNights, minimumNights } = this.props;
    const { getSpecialPricingData } = this.props;

    const dynamicMinimumNights = this.calculateDynamicMinimumNights(startDate);

    // Show tooltip when start date is selected and no end date
    const showMinStayTooltip = startDate && !endDate && focusedInput === START_DATE;

    // Use tracked mouse position for tooltip
    if (showMinStayTooltip && this.lastMousePosition) {
      console.log('[TOOLTIP_DEBUG] Using tracked mouse position:', this.lastMousePosition);
      this.setState({
        tooltipPosition: this.lastMousePosition
      });
    }

    this.setState({ startDate, endDate, dynamicMinimumNights, showMinStayTooltip });
    await change(formName, 'startDate', startDate);
    await change(formName, 'endDate', endDate);

    if (endDate && focusedInput === START_DATE) {
      await change(formName, 'endDate', null);
    }

    if ((focusedInput === END_DATE || focusedInput === START_DATE) && endDate) {
      await getSpecialPricingData(listId, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'));
      await checkAvailability(listId, moment(moment(startDate)).format('YYYY-MM-DD'), moment(moment(endDate)).format('YYYY-MM-DD'), maximumNights, dynamicMinimumNights);
    }

    // Hide tooltip after 3 seconds
    if (showMinStayTooltip) {
      setTimeout(() => {
        this.setState({ showMinStayTooltip: false });
      }, 3000);
    }
  }

  onFocusChange(focusedInput) {
    const { startDate } = this.state;
    this.setState({ focusedInput });
    if (focusedInput === START_DATE) {
      // this.setState({ endDate: null });
    }
  }

  isDayBlocked(day) {
    const { blockedDatesSet } = this.state;
    if (blockedDatesSet) {
      return blockedDatesSet.has(moment(day).format('YYYY-MM-DD'));
    } else {
      return null;
    }
  }

  // Helper function to check if a date is a weekend (Friday or Saturday night)
  isWeekendNight(date) {
    if (!date) return false;
    const dayOfWeek = moment(date).day(); // 0 = Sunday, 5 = Friday, 6 = Saturday
    return dayOfWeek === 6; // Friday or Saturday nights
  }

  // Check if booking includes weekend nights
  bookingIncludesWeekend(startDate, endDate) {
    if (!startDate || !endDate) return false;

    const start = moment(startDate);
    const end = moment(endDate);
    const dayDifference = end.diff(start, 'days');

    // Check each night in the booking range
    for (let i = 0; i < dayDifference; i++) {
      const currentDate = moment(start).add(i, 'day');
      if (this.isWeekendNight(currentDate)) {
        return true;
      }
    }
    return false;
  }

  calculateDynamicMinimumNights(selectedDate) {
    const { minimumNights, blockedDates, weekendPrice, minStayWeekend } = this.props;

    console.log('[MIN_STAY_DEBUG] calculateDynamicMinimumNights called:', {
      selectedDate: selectedDate ? moment(selectedDate).format('YYYY-MM-DD ddd') : 'null',
      minimumNights,
      weekendPrice,
      minStayWeekend,
      hasBlockedDates: blockedDates && Array.isArray(blockedDates)
    });

    if (!selectedDate || !blockedDates || !Array.isArray(blockedDates)) {
      console.log('[MIN_STAY_DEBUG] Early return - no date or blocked dates');
      return minimumNights > 0 ? minimumNights : 1;
    }

    const selectedDateString = moment(selectedDate).format('YYYY-MM-DD');

    // Priority 1: Check for special price min stay
    const matchingDate = blockedDates.find(day =>
      moment(day.blockedDates).format('YYYY-MM-DD') === selectedDateString
    );

    if (matchingDate && matchingDate.specialPriceMinStay && matchingDate.specialPriceMinStay > 0) {
      console.log('[MIN_STAY_DEBUG] Special price min stay:', matchingDate.specialPriceMinStay);
      return matchingDate.specialPriceMinStay;
    }

    // Priority 2: Check for weekend minimum stay
    // Apply 2-night minimum stay when:
    // 1. minStayWeekend is enabled
    // 2. weekendPrice is set
    // 3. The start date is a weekend (Friday or Saturday)
    if (minStayWeekend && weekendPrice && weekendPrice > 0) {
      console.log('[MIN_STAY_DEBUG] Weekend min stay enabled');
      const WEEKEND_MIN_NIGHTS = 2; // Hardcoded 2-night minimum for weekends

      // Check if start date is a weekend night (Friday or Saturday)
      const startIsWeekend = this.isWeekendNight(selectedDate);
      console.log('[MIN_STAY_DEBUG] Start date is weekend?', startIsWeekend, 'dayOfWeek:', moment(selectedDate).day());

      if (startIsWeekend) {
        console.log('[MIN_STAY_DEBUG] Returning weekend minimum (start is weekend):', WEEKEND_MIN_NIGHTS);
        return WEEKEND_MIN_NIGHTS;
      }

      // Check if any day within the weekend minimum range would include a weekend
      // This ensures if user starts on Thursday, they need Thu->Sat (2 nights including weekend)
      // for (let i = 0; i < WEEKEND_MIN_NIGHTS; i++) {
      //   const checkDate = moment(selectedDate).add(i, 'day');
      //   if (this.isWeekendNight(checkDate)) {
      //     console.log('[MIN_STAY_DEBUG] Found weekend in range at day', i, checkDate.format('ddd'), '- Returning:', WEEKEND_MIN_NIGHTS);
      //     return WEEKEND_MIN_NIGHTS;
      //   }
      // }
      console.log('[MIN_STAY_DEBUG] No weekend in range');
    } else {
      console.log('[MIN_STAY_DEBUG] Weekend min stay NOT enabled:', { minStayWeekend, weekendPrice });
    }

    // Priority 3: Base minimum nights
    const baseMin = minimumNights > 0 ? minimumNights : 1;
    console.log('[MIN_STAY_DEBUG] Returning base minimum:', baseMin);
    return baseMin;
  }

  renderMinStayTooltip() {
    const { showMinStayTooltip, dynamicMinimumNights, tooltipPosition } = this.state;

    if (!showMinStayTooltip) return null;

    console.log('[TOOLTIP_DEBUG] Rendering tooltip at position:', tooltipPosition);

    const tooltipText = `Minimum stay: ${dynamicMinimumNights} ${dynamicMinimumNights > 1 ? 'nights' : 'night'}`;

    const tooltipElement = (
      <div style={{
        position: 'fixed',
        left: tooltipPosition.x,
        top: tooltipPosition.y - 50, // Position above the cursor
        transform: 'translateX(-50%)',
        backgroundColor: '#333',
        color: 'white',
        padding: '8px 12px',
        borderRadius: '4px',
        fontSize: '12px',
        whiteSpace: 'nowrap',
        zIndex: 10000,
        pointerEvents: 'none' // Prevent tooltip from interfering with mouse events
      }}>
        {tooltipText}
        <div style={{
          position: 'absolute',
          bottom: '-4px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '4px solid transparent',
          borderRight: '4px solid transparent',
          borderTop: '4px solid #333'
        }} />
      </div>
    );

    // Render tooltip as portal to document body
    return ReactDOM.createPortal(tooltipElement, document.body);
  }


  render() {
    const { focusedInput, startDate, endDate, dynamicMinimumNights } = this.state;
    const { maxDaysNotice, locale, country } = this.props;
    const { formatMessage } = this.props.intl;
    let condition;
    let today = getDateUsingTimeZone(country, false);
    let breakPoint = getDateUsingTimeZone(country, false);


    if (maxDaysNotice === 'unavailable') {
      condition = day =>
        !isInclusivelyAfterDay(day, today) ||
        isInclusivelyAfterDay(day, today)
    } else {
      if (maxDaysNotice === '3months') {
        breakPoint.add(3, 'months');
      } else if (maxDaysNotice === '6months') {
        breakPoint.add(6, 'months');
      } else if (maxDaysNotice === '9months') {
        breakPoint.add(9, 'months');
      } else if (maxDaysNotice === '12months') {
        breakPoint.add(12, 'months');
      }
      if (maxDaysNotice !== 'available') {
        condition = day =>
          !isInclusivelyAfterDay(day, today) ||
          isInclusivelyAfterDay(day, breakPoint)
      } else if (maxDaysNotice == 'available') {
        condition = day => !isInclusivelyAfterDay(day, today)
      }
    }

    return (
      <div style={{ position: 'relative' }} onClick={this.handleCalendarClick}>
        <DateRangePicker
          onDatesChange={this.onDatesChange}
          onFocusChange={this.onFocusChange}
          focusedInput={focusedInput}
          startDate={startDate}
          endDate={endDate}
          numberOfMonths={1}
          startDatePlaceholderText={formatMessage(messages.checkIn)}
          endDatePlaceholderText={formatMessage(messages.checkOut)}
          startDateId={'It is Start date id'}
          endDateId={'It is Start date id'}
          minimumNights={dynamicMinimumNights}
          isOutsideRange={condition}
          hideKeyboardShortcutsPanel
          readOnly
          transitionDuration={0}
          anchorDirection={isRTL(locale) ? 'right' : 'left'}
          isRTL={isRTL(locale)}
          renderCalendarDay={props => <CustomBookingFormDay {...props} />} //viewListingMainCalendar and contact host
          isDayBlocked={day => this.isDayBlocked(day)}
        />
        {this.renderMinStayTooltip()}
      </div>
    );
  }
}

const bookingFormSelector = formValueSelector('BookingForm');
const contactFormSelector = formValueSelector('ContactHostForm');

const mapState = state => ({
  isLoading: state.viewListing.isLoading,
  availability: state.viewListing.availability,
  bookingStartDate: bookingFormSelector(state, 'startDate'),
  bookingEndDate: bookingFormSelector(state, 'endDate'),
  contactStartDate: contactFormSelector(state, 'startDate'),
  contactEndDate: contactFormSelector(state, 'endDate'),
  locale: state.intl.locale,
  isFullDayBlock: state.viewListing.isFullDayBlock
});

const mapDispatch = {
  checkAvailability,
  change,
  getSpecialPricingData
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(DateRange)));
